import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private _apiSettings = environment.restAPI;

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Do not modify the request headers (e.g. disable caching) for the service call that gets the public IP address
    if (req.url === this._apiSettings.publicIpAddressServiceUrl) {
      return next.handle(req);
    } else {
      const httpRequest = req.clone({
        headers: new HttpHeaders({
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: 'Sat, 01 Jan 2000 00:00:00 GMT'
        })
      });
      return next.handle(httpRequest);
    }
  }
}
